module.exports = __webpack_public_path__ + "static/media/hr-request-manager.fe336f01.svg";